import React from "react";
import '../styles/FormRow.css';

const FormRow = (props) => {
    return (
        <div className="form-row">
            {props.children}
        </div>
    )
}
export default FormRow;